import { dropdowns, menuComputers } from '@/data'
import { EventType } from '@/constants/event'
import { Dropdown, MenuComputer } from '@/types'
import { ElMessage, ElMessageBox } from 'element-plus'
import { EventBus } from '@/utils/eventBus'

export function createPluginApp(eventBus: EventBus) {
  const app = eventBus as any
  app.EVENT = EventType
  app.services = {
    showMessage(
      level: 'success' | 'warning' | 'info' | 'error',
      title: string,
      content: string,
      duration: number
    ) {
      ElMessage({
        type: level,
        message: title + content,
        duration,
      })
    },
    showMessageBox(title: string, content: string, options: any) {
      return ElMessageBox.confirm(content, title, options)
    },
    addMenuComputer(computer: MenuComputer) {
      menuComputers.push(computer)
    },
    addDropdowns(...dps: Dropdown[]) {
      dropdowns.push(...dps)
    },
  }
  return app
}
